export type ClientHubPwaBranding = {
  readonly businessDisplayName: string;
  readonly logoUrl: string | null;
};

let lastManifestHref: string | null = null;

function upsertMeta(name: string, content: string): void {
  if (typeof document === "undefined") return;
  let node = document.head.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!node) {
    node = document.createElement("meta");
    node.name = name;
    document.head.appendChild(node);
  }
  node.content = content;
}

function upsertLink(rel: string, href: string, extra?: Record<string, string>): void {
  if (typeof document === "undefined") return;
  const selector = extra?.sizes
    ? `link[rel="${rel}"][sizes="${extra.sizes}"]`
    : `link[rel="${rel}"]`;
  let node = document.head.querySelector(selector) as HTMLLinkElement | null;
  if (!node) {
    node = document.createElement("link");
    node.rel = rel;
    if (extra) {
      for (const [key, value] of Object.entries(extra)) {
        node.setAttribute(key, value);
      }
    }
    document.head.appendChild(node);
  }
  node.href = href;
}

export function brandingLetterMark(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return "B";
  return trimmed.slice(0, 1).toUpperCase();
}

export function letterMarkIconDataUrl(name: string): string {
  const letter = brandingLetterMark(name);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192"><rect width="192" height="192" rx="40" fill="#1f4f8a"/><text x="96" y="124" text-anchor="middle" font-size="92" fill="#ffffff" font-family="system-ui,sans-serif">${letter}</text></svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

export function applyClientHubPwaBranding(input: ClientHubPwaBranding): void {
  if (typeof document === "undefined") return;
  const name = input.businessDisplayName.trim() || "Client workspace";
  document.title = name;
  upsertMeta("apple-mobile-web-app-title", name);

  const icon = input.logoUrl ?? letterMarkIconDataUrl(name);
  const manifest = {
    name,
    short_name: name.slice(0, 32),
    start_url: ".",
    display: "standalone",
    background_color: "#f7f8f9",
    theme_color: "#f7f8f9",
    icons: [
      { src: icon, sizes: "192x192", type: input.logoUrl ? "image/png" : "image/svg+xml" },
      { src: icon, sizes: "512x512", type: input.logoUrl ? "image/png" : "image/svg+xml" },
    ],
  };
  const blob = new Blob([JSON.stringify(manifest)], { type: "application/manifest+json" });
  const href = URL.createObjectURL(blob);
  if (lastManifestHref) URL.revokeObjectURL(lastManifestHref);
  lastManifestHref = href;
  upsertLink("manifest", href);
  upsertLink("apple-touch-icon", icon);
}
